export default __webpack_public_path__ + "static/media/product-2.cc489b84.jpg";